import { Component } from "react"
import PropTypes from "prop-types"

import styles from "./hover_trigger.module.scss"

export default class HoverTrigger extends Component {
  state = {
    hoverable: true,
  }

  onHover = () => {
    this.state.hoverable && this.setState({ hoverable: false })
  }

  onMouseLeave = e => {
    this.setState({ hoverable: true })
  }

  render() {
    return (
      <div className={styles[this.props.triggerLocation]} onMouseOver={this.onHover}>
        {!this.state.hoverable && (
          <div onMouseLeave={this.onMouseLeave} className={styles["panel-container"]}>
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

HoverTrigger.propTypes = {
  triggerLocation: PropTypes.string,
}
